import localeNl from '@angular/common/locales/nl';
import { EnvironmentInterface } from '@sk/sk-interfaces';

export const environment : EnvironmentInterface = {
  production: true,
  language: 'nl-NL',
  scheduleCheck: false,
  region: 'nl',
  locale : localeNl,
  firebase: {
    apiKey: "AIzaSyBdvL6C9eS2hC4Po3xOggWZCSco1zagLVc",
    authDomain: "eu-servicekicker.firebaseapp.com",
    databaseURL: "https://eu-servicekicker.firebaseio.com",
    projectId: "eu-servicekicker",
    storageBucket: "eu-servicekicker.appspot.com",
    messagingSenderId: "342892714251",
    appId: "1:342892714251:web:6e5e433634fed6a1e2aa0e"
  },
  api_url: 'https://europe-west1-eu-servicekicker.cloudfunctions.net',
  release: 'd.nl_nl 0.0.12',
  releaseCompany: 'JobLog Nederland B.V.',
  base_url : ''
};
